import { render, staticRenderFns } from "./summaryCard.vue?vue&type=template&id=43fa19d1&"
import script from "./summaryCard.vue?vue&type=script&lang=js&"
export * from "./summaryCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports